export const BLANK_DATE = 'BLANK';
const getValue = previewEntry => {
  const {
    value,
    default: defaultValue
  } = previewEntry;
  const entryValue = value || defaultValue;
  if (entryValue === BLANK_DATE) {
    return '';
  }
  return entryValue;
};
const hasValue = previewEntry => {
  const value = getValue(previewEntry);
  return !!value;
};
const isRequired = previewEntry => {
  const errorMessage = 'This field is required';
  const {
    required
  } = previewEntry;
  if (required && !hasValue(previewEntry)) {
    return errorMessage;
  }
};
export default [{
  validation: isRequired,
  type: 'required'
}];